<template>
  <div class="mfa-container">
    <div
      class="d-none mfa-modal"
      id="modal-mfa"
    >
      <div class="mfa-modal-inner">
        <div class="d-flex w-100 justify-content-between mt-4 pb-3 border-bottom border-secondary">
          <h5 class="m-0">Verifica-ti numarul</h5>
          <button
            type="button"
            class="close"
            @click="closeModal"
          >
            <span aria-hidden="true" style="font-size: 32px;">&times;</span>
          </button>
        </div>
        <h3 class="mt-2 mt-sm-4 mb-2 mb-sm-4"><b>Codul tau de verificare pentru promocolgatepalmolive este:</b></h3>
        <div class="d-flex justify-content-center align-items-center">
          <ValidationObserver>
            <v-otp-input
              ref="otpInput"
              input-classes="otp-input"
              separator=""
              :num-inputs="4"
              :should-auto-focus="true"
              :is-input-num="true"
              input-type="number"
              input-mode="numeric"
              @on-change="handleOnChange"
              @on-complete="handleOnComplete"
            />
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: 'mfa',
  data () {
    return {
      modal: null
    }
  },
  props: {
    generateEndpoint: {
      type: String,
      default: '/mobileAuth'
    },
    verifyEndpoint: {
      type: String,
      default: '/mobileVerification'
    },
    successAction: {
      type: Object,
      default: () => null
    }
  },
  mounted() {
    this.$eventHub.$on("startMFA-event", this.showModal)
    this.modal = document.getElementById('modal-mfa')
  },
  computed: {
    ...mapGetters(["customerToken", "campaignId", "customerMobile", "receiptToken"])
  },
  methods: {
    handleOnComplete(value) {
      this.verifyCode(value)
    },
    handleOnChange(value) {
      // console.log('OTP changed: ', value);
    },
    clearForm() {
      this.$refs.otpInput.clearInput()
    },
    showModal() {
      const formData = {}

      let mobile = this.customerMobile
      if (mobile.startsWith('0')) mobile = mobile.slice(1)

      formData.customerToken = this.customerToken
      formData.campaignId = this.campaignId
      formData.mobile = `+40${mobile}`

      this.$store
        .dispatch("sendFormData", { formData, endpoint: this.generateEndpoint })
        .then(r => {
          if (r.response) {
            this.$eventHub.$emit("done-event-trigger", {
              parent: this,
              status: true
            })
            this.modal.classList.remove('d-none')
            document.body.classList.add('modal-open')
          }
        })
        .catch(() => {
          this.$eventHub.$emit("done-event-trigger", {
            parent: this,
            status: false
          })
        })
    },
    closeModal() {
      this.modal.classList.add('d-none')
      document.body.classList.remove('modal-open')
    },
    verifyCode(value) {
      const formData = {}

      if (this.locale) {
        formData.lang = this.locale
      }
      let mobile = this.customerMobile
      if (mobile.startsWith('0')) mobile = mobile.slice(1)

      formData.customerToken = this.customerToken
      formData.receiptToken = this.receiptToken
      formData.campaignId = this.campaignId
      formData.mobile = `+40${mobile}`
      formData.code = value

      this.$store
        .dispatch("sendFormData", { formData, endpoint: this.verifyEndpoint })
        .then(r => {
          if (r.response) {
            const fn = this.successAction.fn;
            const params = this.successAction.params;
            this[fn](params, this);
            this.$eventHub.$emit("done-event-trigger", {
              parent: this,
              status: true
            })
            this.$store.commit("setField", {
              field: "formData",
              value: {
                ...formData,
                ...r
              }
            });
            this.clearForm()
            this.closeModal()
          }
        })
        .catch(() => {
          this.$eventHub.$emit("done-event-trigger", {
            parent: this,
            status: false
          })
        })
    }
  },
  beforeDestroy() {
    this.$eventHub.$off('startMFA-event')
    this.clearForm()
  }
}
</script>

<style scoped lang="scss">
.mfa-container {
  @media (max-width: 767px) {
    margin-bottom: 50px;
  }

  .mfa-modal {
    width: 100vw;
    height: 100vh;
    z-index: 1040;
    background-color: #4c4c4c1a;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    &-inner {
      width: 45%;
      height: 40%;
      background-color: #EDF2F7;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      border-radius: 8px;
      outline: 32px solid #fff;
      padding: 10px 40px;

      @media (max-width: 1100px) {
        h3 { font-size: 20px; }
      }

      @media (max-width: 576px) {
        width: calc(80% - 16px);
        h3 { font-size: 18px; }
        h5 { font-size: 16px; }
      }

      @media (max-width: 300px) {
        h3 { font-size: 14px; }
        h5 { font-size: 12px; }
      }

      @media (max-height: 767px) {
        height: 50%;
      }

      @media (max-height: 450px) {
        height: 80%;
      }
    }
  }

  ::v-deep .otp-input {
    width: 72px;
    height: 81px;
    padding: 5px;
    margin: 0 10px;
    font-size: 32px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;

    @media (max-width: 870px) {
      width: 48px;
      height: 54px;
    }

    @media (max-width: 630px) {
      font-size: 16px;
      width: 40px;
      height: 45px;
    }

    @media (max-width: 300px) {
      width: 32px;
      height: 36px;
    }

    &.error {
      border: 1px solid red !important;
    }
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>